"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDateToString = void 0;
const DayOfWeek_1 = require("../utils/DayOfWeek");
const transformDateToMonthNameString_1 = require("./transformDateToMonthNameString");
function transformDateToString(date, showDayOfWeek = false) {
    const dateToString = new Date(date);
    const year = dateToString.getUTCFullYear().toString();
    const month = (0, transformDateToMonthNameString_1.transformDateToMonthNameString)(dateToString);
    const day = dateToString.getUTCDate().toString();
    let dayOfWeek = "";
    if (showDayOfWeek) {
        dayOfWeek = `${DayOfWeek_1.DaysOfWeek[dateToString.getUTCDay()]}, `;
    }
    return `${dayOfWeek}${month} ${day}, ${year}`;
}
exports.transformDateToString = transformDateToString;
//# sourceMappingURL=transformDateToString.js.map